import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const lisaInstituteTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.lisa_institute,
  logoUrl: "https://cdn.nemuru.com/assets/logos/lisa-institute-logo.svg",
  palette: {
    primary: {
      main: "#0077BD",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FFBE00",
      contrastText: "#000",
    },
    warning: {
      main: "#d87b26",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    text: {
      title: "#0077BD",
      primary: "#53575A",
      secondary: "#8C8D8E",
    },
    info: {
      main: "#00327D",
      contrastText: "#fff",
      light: "#cce0ff",
    },
    success: {
      main: "#519f4c",
      contrastText: "#ffffff",
      light: "#6df39e96",
    },
    error: {
      main: "#dc0723",
      contrastText: "#ffffff",
      light: "#ff8e9c",
    },
    // additional colors
    dark: {
      main: "#003453",
      accent: "#FFBE00",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#2ea3f2",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  customBorderRadius: {
    button: 0,
    paper: 8,
    chip: 100,
  },
  typography: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  },
};
